<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="1500px">
        <v-card>
          <v-toolbar
              color="primary"
              dark
            ><v-card-title class="d-flex justify-space-between"> PDS {{ this.status }}</v-card-title>
            <v-spacer></v-spacer>
                 <v-btn icon @click="dialog = false" >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <!-- <v-col cols="12">
                    <v-btn color="primary" class="ml-auto">
                      <download-csv :data="exportData" :name="`${fileName}.csv`">
                        <v-icon dense>mdi-download</v-icon>
                        Export
                      </download-csv>
                    </v-btn>
                  </v-col> -->

                <v-col cols="12" class="mt-0 pt-0">
                  <v-data-table
                    :page="table.page"
                    :pageCount="table.numberOfPages"
                    :options.sync="options"
                    :server-items-length="table.total"
                    :headers="table.headers"
                    :items="table.data"
                    :items-per-page="10"
                    :loading="table.loading"
                    item-key="id"
                    loading-text="Loading... Please wait"
                    class="elevation-1"
                    :footer-props="{
                      'items-per-page-options': [10, 20, 50, 100],
                    }"
                    dense
                  >
                    <template
                      v-for="header in table.headers.filter((header) =>
                        header.hasOwnProperty('formatter')
                      )"
                      v-slot:[`item.${header.value}`]="{ value }"
                    >
                      {{ header.formatter(value) }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>

            <v-btn @click.native="cancel">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";

export default {
  mixins: [ShareableMethods],
  name: "pdsDetailsList",
  data() {
    return {
      exportData: [],
      fileName: "",

      dialog: false,
      resolve: null,
      reject: null,

      table: {
        page: 0,
        total: 0,
        numberOfPages: 0,

        expanded: [],
        singleExpand: false,
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          { text: "Name", value: "subscriberName" },
          {
            text: "Disconnection Date",
            value: "disconnectionDate",
            formatter: (x) => (x ? this.formatDate(x) : null),
          },
          // { text: "Mobile Number", value: "mobileNumber" },
          // { text: "Affiliator Details", value: "affiliate" },
          { text: "Customer Type", value: "typeOfCustomer" },
          { text: "Subscription", value: "subscriptionPackageName" },
          {
            text: "Endorsed",
            value: "endorse.endorseDate",
            formatter: (x) => (x ? this.formatDate(x) : null),
          },

          // {
          //     text: "Date Uploaded",
          //     value: "createdAt",
          //    // formatter: (x) => (x ? this.formatDate(x) : null),
          // },

          // {
          //     text: "Installation Date",
          //     value: "installationDate",
          //     formatter: (x) => (x ? this.formatDate(x, "ddd MMM. DD") : null),
          // },

          // {
          //     text: "Retry",
          //     value: "nextCall.retry",
          // },
          {
              text: "Channel",
              value: "channel",
              formatter: (x) => (x ? x : "BULK"),
          },
          {
            text: "Aging",
            value: "endorse.aging",
            formatter: (x) => (x >= 0 ? x + " D" : ""),
          },

          // {
          //   text: "Next Call Date",
          //   value: "nextCallDate",
          //   formatter: (x) =>
          //     x ? this.formatDate(x, "ddd MMM. DD") : null,
          // },
        ],
        data: [],
      },

      options: {
        page: 1,
      },
      status: "",
      distributorId: 0,
    };
  },

  methods: {
    open(data, status) {
      this.dialog = true;
      this.status = status;
      this.distributorId = data.distributorId;
      this.options = {
        page: 1,
      };
      this.getPDSDetails(data.distributorId, this.status);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    async getPDSDetails(distributorId, status, searchVal = "") {
      this.table.loading = true;
      const { page, itemsPerPage } = this.options;
      let pageNumber = "";
      if (itemsPerPage === -1) {
        pageNumber = "";
      } else {
        pageNumber = page ? page : 1;
      }
      const perPage = itemsPerPage < 0 ? "" : itemsPerPage;
      await this.$pds
        .get(
          `/pds?status=${status}&distributorId=${distributorId}&page=${pageNumber}&limit=${perPage}&searchVal=${searchVal}`
        )
        .then((response) => {
          //console.log(response)
          this.table.loading = false;
          const newArr = response.data;
          this.table.total = newArr.totalCount;
          this.table.numberOfPages = newArr.totalPages;
          console.log(newArr.data.customers);
          this.table.data = newArr.data.customers;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },

    options: {
      handler() {
        this.getPDSDetails(this.distributorId, this.status, this.search);
      },
      deep: true,
    },
  },
};
</script>
